/**
 * FAQ content.
 *
 * Extracted verbatim from `public/index.html:366-472`.
 */

export interface FaqEntry {
  question: string;
  answer: string[];
}

export const FAQ_ENTRIES: FaqEntry[] = [
  {
    question: 'What makes LungChat different from other analysis tools?',
    answer: [
      'LungChat integrates single-cell RNA-seq, spatial transcriptomics, drug repurposing, cell-cell communication analysis, functional enrichment, and literature research in a unified natural language interface. Unlike traditional tools that require coding expertise, LungChat enables researchers to perform complex multiomics analyses through conversational queries—from differential expression to finding therapeutic candidates—while ensuring full reproducibility with complete parameter tracking and publication-ready outputs.'
    ]
  },
  {
    question: 'What datasets are available in LungChat?',
    answer: [
      'LungChat integrates 2.8M+ cells from 470+ donors across 40+ single-cell RNA-seq studies covering normal lung, development, and 15+ disease states (IPF, COPD, COVID-19, BPD, lung cancer, and more). Datasets include the Human Lung Cell Atlas (HLCA) with 35 author studies, fetal development atlases, and disease-specific cohorts. Spatial transcriptomics data includes Xenium and Visium platforms with multi-resolution annotations for tissue niches, cellular communication analysis with CellChat, and integrated histology imaging.'
    ]
  },
  {
    question: 'Is LungChat free to use? Are there any usage limits?',
    answer: [
      'Yes, LungChat is freely available for research purposes. To ensure fair access and system stability, each user can submit up to 15 queries per day and 50 queries per week.'
    ]
  },
  {
    question: 'How does LungChat ensure reproducibility?',
    answer: [
      'Every analysis generates publication-ready figures (PNG/PDF), data tables (TSV), and complete parameter logs (JSON) containing all analysis parameters, dataset identifiers, and tool configurations. This ensures full provenance tracking and allows anyone to reproduce the exact analysis, meeting the highest standards of scientific reproducibility.'
    ]
  },
  {
    question: 'How does drug repurposing work in LungChat?',
    answer: [
      'LungChat uses connectivity mapping to match your disease gene signatures against 143K+ drug perturbation profiles from the iLINCS database. It identifies compounds whose effects could reverse disease signatures, helping prioritize candidates for therapeutic development. You can also investigate specific drug mechanisms, explore gene knockout effects, and discover structurally similar compounds—all through natural language queries.'
    ]
  },
  {
    question: 'Can I upload my own datasets?',
    answer: [
      "Currently, LungChat works with pre-integrated datasets from the LungMAP consortium and published studies. Support for user-uploaded datasets is planned for future releases. Contact us if you have specific datasets you'd like integrated or if you're interested in collaborating."
    ]
  }
];
